<ep-app-root></ep-app-root>

<ng-template #dialogTemplateFav let-data="data">
  <div class="ep-fav-edit-dialog">
    <div *ngIf="data">
      <div class="input-group">
        <ep-text-box [(ngModel)]="data.name" labelText="{{appStrings.itemName}}" class="ep-input-block"></ep-text-box>
      </div>
      <div class="form-group">
        <div *ngIf="!data.isNewFolder" class="ep-fav-edit-folder">
          <label>{{appStrings.folder}}</label>
          <ep-dropdown [defaultItem]="defaultItem" [data]="data.folders" [(ngModel)]="data.folder" textField="caption"
            valueField="id"></ep-dropdown>
          <i class="mdi mdi-folder-plus pull-right ep-fav-edit-folder-icon" (click)="addFolder(1)"></i>
        </div>
        <div *ngIf="data.isNewFolder" class="ep-fav-edit-new-folder">
          <ep-text-box [(ngModel)]="data.newFolder" labelText="{{appStrings.newFolder}}"></ep-text-box>
          <i class="mdi mdi-folder-remove pull-right ep-fav-edit-folder-icon" (click)="addFolder(0)"></i>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #editFavFolderNameTemplate let-data="data">
  <div>
    <ep-text-box labelText="{{appStrings.folderName}}" [(ngModel)]=" data.folder"></ep-text-box>
  </div>
</ng-template>
